import withStyles from "react-jss"
import colors from "../../data/colors"

const w = 22,
  h = 22

const whiteOutlineStyles = {
  svg: {
    width: `${w}px`,
    height: `${h}px`,
    background: colors.black,
    marginBottom: "-5px",
    borderRadius: "2px",
  },
}

const AnnotationLegend = ({ classes, type = "outline" }) => {
  const styles = (type) => {
    const outlineStyles = {
        fill: "transparent",
        stroke: colors.lightBlue,
        strokeWidth: 1,
      },
      fillStyles = {
        fill: colors.lightBlue,
        stroke: colors.lightBlue,
        strokeWidth: 1,
      },
      parenthoodFillStyles = {
        fill: colors.ageUnder35,
        stroke: colors.ageUnder35,
        strokeWidth: 1,
      }
    const mapping = {
      "": fillStyles, // default
      fill: fillStyles,
      outline: outlineStyles,
      parenthoodFill: parenthoodFillStyles,
    }
    return mapping[type]
  }

  return (
    <svg
      className={classes.svg}
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true">
      <circle r="6" cx={w / 2} cy={h / 2} {...styles(type)} strokeWidth="1" />
    </svg>
  )
}

export default withStyles(whiteOutlineStyles)(AnnotationLegend)
